import { Component } from '@angular/core';

@Component({
  selector: 'sh-main-loader',
  templateUrl: './main-loader.component.html',
  styleUrls: ['./main-loader.component.scss']
})
export class MainLoaderComponent {}
